module.exports = __webpack_public_path__ + "img/xml.9d918dfe.png";